import EduContentModel from '../Apis/EduContent'
import Controller from './Controller'
 
export default class EduContentController extends Controller {
  constructor(eduCourseId) {
    super(new EduContentModel(eduCourseId))
  }
  async getAllContents(eduProgramId, params) {
    const res = await this.model.getAllContents(eduProgramId, params)
    return res.data
  }
  async Insert(data, eduCourseId, headers = {}) {

    const options = {
      /**
       * include array indices in FormData keys
       * defaults to false
       */
      indices: true,

      /**
       * treat null values like undefined values and ignore them
       * defaults to false
       */
      nullsAsUndefineds: false,

      /**
       * convert true or false to 1 or 0 respectively
       * defaults to false
       */
      booleansAsIntegers: false,

      /**
       * store arrays even if they're empty
       * defaults to false
       */
      allowEmptyArrays: true,
    };

    const formData = serialize(
      data,
      options, // optional
    );

    headers = {
      headers: {
        'Content-Type': 'multipart/form-data',
        charset: 'utf-8',
        boundary: Math.random().toString().substr(2),
      },

    }

 

    let res = await this.model.Insert(formData, eduCourseId, headers)
    //status
    return this.Poup(res);

   }
  async Order(data, headers = {}){
    
    let res = await this.model.Order(data, headers)
    

  }
  Types(all = true) {
    return this.model.Types(all);
  }
  GetType(type) {
    return this.model.GetType(type);
  }
}
